export default __webpack_public_path__ + "static/media/button_placement_settings.5d89ff87.png";